var Theme = Theme || {};

Theme.BuyThisResourceLink = (function ($) {
    let $widget;

    return {
        init: _init
    };

    function _init() {
        $widget = $('.purchase-book-products');

        if (!$widget.length) {
            return;
        }

        $widget.on('change', '.js-book-purchase-format-selector', function () {
            _selectFormat($(this).data());
        });

        $widget.on('click', '.js-book-purchase-btn', function () {
            const url = _buildStoreUrl();
            if (url) {
                window.location.href = url;
            }
        });

        $widget.on('click', '.js-book-purchase-qty-minus', function () {
            const $input = $widget.find('.js-book-purchase-qty-value');
            const val = parseInt($input.val(), 10);
            if (val > 1) {
                $input.val(val - 1);
            }
        });

        $widget.on('click', '.js-book-purchase-qty-plus', function () {
            const $input = $widget.find('.js-book-purchase-qty-value');
            const val = parseInt($input.val(), 10);
            $input.val(val + 1);
        });

        _selectFormat(_getSelectedFormat());

        // Relocate logic only applies when a TOC placeholder exists on the page
        if (!$('.purchase-book-products-toc').length) {
            return;
        }

        $(window).on('resize', debounce(_relocate, 150));
        _relocate();
    }

    function _isNarrowViewPort() {
        return SCM.SiteJS.getViewportWidth() <= 1023;
    }

    function _getSelectedFormat() {
        const $radio = $widget.find('.js-book-purchase-format-selector:checked');
        if ($radio.length) {
            return $radio.data();
        }

        const $hidden = $widget.find('.js-book-purchase-format-selector');
        if ($hidden.length) {
            return $hidden.data();
        }

        return null;
    }

    function _selectFormat(selected) {
        if (!selected) {
            return;
        }

        $widget.find('.js-book-purchase-price').text(selected.price);
        $widget.find('.js-book-purchase-btn-text').text(selected.buttonText);

        const $date = $widget.find('.js-book-purchase-date');
        if (selected.isPreOrder && selected.publicationDate) {
            $date.text('Available on ' + selected.publicationDate).removeClass('hide');
        } else {
            $date.addClass('hide');
        }

        const $qty = $widget.find('.js-book-purchase-quantity');
        if (selected.isEbook) {
            $qty.addClass('quantity-disabled');
            $qty.find('.qty-btn').prop('disabled', true);
        } else {
            $qty.removeClass('quantity-disabled');
            $qty.find('.qty-btn').prop('disabled', false);
        }

        $widget.find('.js-book-purchase-qty-value').val(1);
    }

    function _buildStoreUrl() {
        const selected = _getSelectedFormat();
        if (!selected) {
            return null;
        }
        const url = new URL(selected.storeUrl, window.location.origin);
        if (!selected.isEbook) {
            const qty = parseInt($widget.find('.js-book-purchase-qty-value').val(), 10);
            if (qty > 1) {
                url.searchParams.set('quantity', qty);
            }
        }
        return url.toString();
    }

    function _relocate() {
        if (_isNarrowViewPort()) {
            $('.purchase-book-products-toc').append($widget);
        } else {
            $('.sidebar-widget_wrap').prepend($widget);
        }
    }
})(jQuery);
